// --- 1. 移动端菜单逻辑 ---
const menuBtn = document.getElementById('menu-btn');
const mobileMenu = document.getElementById('mobile-menu');
const mobileLinks = document.querySelectorAll('.mobile-link');

menuBtn.addEventListener('click', () => {
    mobileMenu.classList.toggle('open');
});

mobileLinks.forEach(link => {
    link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
    });
});

// --- 2. Three.js Dot-Matrix Particle Field Setup ---
const initWebGL = () => {
    const canvas = document.getElementById('webgl-canvas');
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    const scene = new THREE.Scene();
    // 适配浅色背景的深度迷雾
    scene.fog = new THREE.FogExp2(0xFAFAFA, 0.0015);

    const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 2000);
    camera.position.z = 1000;

    // 创建星空粒子场
    const particleCount = 4000;
    const geometry = new THREE.BufferGeometry();
    const positions = new Float32Array(particleCount * 3);
    const opacities = new Float32Array(particleCount);

    for (let i = 0; i < particleCount; i++) {
        positions[i * 3] = (Math.random() - 0.5) * 3000;     
        positions[i * 3 + 1] = (Math.random() - 0.5) * 3000; 
        positions[i * 3 + 2] = (Math.random() - 0.5) * 2000; 
        opacities[i] = Math.random();
    }

    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    geometry.setAttribute('aOpacity', new THREE.BufferAttribute(opacities, 1));

    // 自定义 Shader 材质：实现呼吸闪烁与鼠标邻近变红
    const material = new THREE.ShaderMaterial({
        uniforms: {
            uTime: { value: 0.0 },
            uMousePixel: { value: new THREE.Vector2(-1000, -1000) },
            uResolution: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) }
        },
        vertexShader: `
            uniform float uTime;
            uniform vec2 uMousePixel;
            uniform vec2 uResolution;
            attribute float aOpacity;
            varying float vOpacity;
            varying vec3 vColor;
            void main() {
                vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
                gl_Position = projectionMatrix * mvPosition;
                
                // 计算屏幕二维像素坐标
                vec2 screenPos = (gl_Position.xy / gl_Position.w) * 0.5 + 0.5;
                screenPos.y = 1.0 - screenPos.y;
                screenPos *= uResolution;
                
                // 计算与鼠标的距离，80像素内开始变色
                float dist = distance(screenPos, uMousePixel);
                float mixRatio = 1.0 - smoothstep(30.0, 80.0, dist);
                
                // 基础色：高级灰 (156,163,175) -> 品牌红 (230,0,18)
                vec3 baseColor = vec3(0.61, 0.64, 0.68); 
                vec3 highlightColor = vec3(0.90, 0.0, 0.07); 
                vColor = mix(baseColor, highlightColor, mixRatio);
                
                // 呼吸动画 + 鼠标悬停高亮
                vOpacity = aOpacity * (0.3 + 0.7 * sin(uTime * 0.5 + aOpacity * 10.0));
                vOpacity = max(vOpacity, mixRatio * 0.9);
                
                gl_PointSize = (4.0 / -mvPosition.z) * 1000.0; 
            }
        `,
        fragmentShader: `
            varying float vOpacity;
            varying vec3 vColor;
            void main() {
                float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
                if(distanceToCenter > 0.5) discard;
                gl_FragColor = vec4(vColor, vOpacity * 0.5);
            }
        `,
        transparent: true,
        depthWrite: false,
        blending: THREE.NormalBlending 
    });

    const particles = new THREE.Points(geometry, material);
    scene.add(particles);

    // --- 动态连线 (Plexus) 设置 ---
    const maxLines = 150;
    const lineGeo = new THREE.BufferGeometry();
    const linePos = new Float32Array(maxLines * 6);
    const lineCol = new Float32Array(maxLines * 6);
    lineGeo.setAttribute('position', new THREE.BufferAttribute(linePos, 3));
    lineGeo.setAttribute('color', new THREE.BufferAttribute(lineCol, 3));
    
    const lineMat = new THREE.LineBasicMaterial({
        vertexColors: true,
        transparent: true,
        opacity: 0.7,
        depthWrite: false
    });
    const linesMesh = new THREE.LineSegments(lineGeo, lineMat);
    scene.add(linesMesh);

    // 鼠标追踪
    let mouseX = 0;
    let mouseY = 0;
    let targetX = 0;
    let targetY = 0;
    let rawMouseX = -1000;
    let rawMouseY = -1000;
    const windowHalfX = window.innerWidth / 2;
    const windowHalfY = window.innerHeight / 2;

    document.addEventListener('mousemove', (event) => {
        mouseX = (event.clientX - windowHalfX) * 0.5;
        mouseY = (event.clientY - windowHalfY) * 0.5;
        rawMouseX = event.clientX;
        rawMouseY = event.clientY;
    });

    const clock = new THREE.Clock();
    const mvpMatrix = new THREE.Matrix4();
    const proj = new THREE.Vector3();

    const animate = () => {
        requestAnimationFrame(animate);

        const elapsedTime = clock.getElapsedTime();
        material.uniforms.uTime.value = elapsedTime;
        material.uniforms.uMousePixel.value.set(rawMouseX, rawMouseY);

        // 缓慢自我旋转
        particles.rotation.y += 0.0005;
        particles.rotation.x += 0.0002;
        linesMesh.rotation.copy(particles.rotation); // 让连线跟着粒子同步旋转

        // 视差平滑过渡
        targetX = mouseX * 0.1;
        targetY = mouseY * 0.1;
        camera.position.x += (targetX - camera.position.x) * 0.02;
        camera.position.y += (-targetY - camera.position.y) * 0.02;
        camera.lookAt(scene.position);

        // --- 核心：计算连线 ---
        camera.updateMatrixWorld();
        particles.updateMatrixWorld();
        mvpMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        const fullMatrix = new THREE.Matrix4().multiplyMatrices(mvpMatrix, particles.matrixWorld);

        // 计算鼠标在 3D 空间中的近似发射点 (Z=0 平面)
        let mNDC = new THREE.Vector3((rawMouseX / window.innerWidth) * 2 - 1, -(rawMouseY / window.innerHeight) * 2 + 1, 0.5);
        mNDC.unproject(camera);
        let rayDir = mNDC.sub(camera.position).normalize();
        let distPlane = -camera.position.z / rayDir.z;
        let mouse3D = camera.position.clone().add(rayDir.multiplyScalar(distPlane));

        // 将 3D 鼠标坐标转换为粒子的局部坐标系
        let invObjMatrix = new THREE.Matrix4().copy(particles.matrixWorld).invert();
        let localMouse3D = mouse3D.clone().applyMatrix4(invObjMatrix);

        let lineCount = 0;
        const posArray = particles.geometry.attributes.position.array;

        // 遍历寻找附近的粒子并连线
        for(let i = 0; i < particleCount; i++) {
            proj.set(posArray[i*3], posArray[i*3+1], posArray[i*3+2]);
            proj.applyMatrix4(fullMatrix);
            
            // 剔除摄像机背后的粒子
            if(proj.z > 1 || proj.z < -1) continue; 
            
            // 转换到屏幕像素坐标
            let px = (proj.x * 0.5 + 0.5) * window.innerWidth;
            let py = -(proj.y * 0.5 - 0.5) * window.innerHeight;
            
            let dx = px - rawMouseX;
            let dy = py - rawMouseY;
            let distSq = dx*dx + dy*dy;
            
            // 80 像素半径内生成连线
            if(distSq < 6400 && lineCount < maxLines) {
                linePos[lineCount*6]     = localMouse3D.x;
                linePos[lineCount*6 + 1] = localMouse3D.y;
                linePos[lineCount*6 + 2] = localMouse3D.z;
                linePos[lineCount*6 + 3] = posArray[i*3];
                linePos[lineCount*6 + 4] = posArray[i*3+1];
                linePos[lineCount*6 + 5] = posArray[i*3+2];
                
                // 动态颜色：中心纯红，边缘自然融入背景白 (#FAFAFA)
                let ratio = 1.0 - (Math.sqrt(distSq) / 80.0);
                let r = 0.98 - (0.98 - 0.90) * ratio;
                let g = 0.98 - (0.98 - 0.00) * ratio;
                let b = 0.98 - (0.98 - 0.07) * ratio;
                
                lineCol[lineCount*6] = r; lineCol[lineCount*6+1] = g; lineCol[lineCount*6+2] = b;
                lineCol[lineCount*6+3] = r; lineCol[lineCount*6+4] = g; lineCol[lineCount*6+5] = b;
                
                lineCount++;
            }
        }
        
        linesMesh.geometry.setDrawRange(0, lineCount * 2);
        linesMesh.geometry.attributes.position.needsUpdate = true;
        linesMesh.geometry.attributes.color.needsUpdate = true;

        renderer.render(scene, camera);
    };

    animate();

    // 响应窗口调整
    window.addEventListener('resize', () => {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
        material.uniforms.uResolution.value.set(window.innerWidth, window.innerHeight);
    });
};

// --- 3. SPA Page Routing & GSAP Animations ---
gsap.registerPlugin(ScrollTrigger);
let currentScrollTriggers = [];

// 针对特定页面初始化 GSAP 动画
const initGSAPForPage = (section) => {
    // 清理旧的 ScrollTriggers，防止重新计算高度导致跳动
    currentScrollTriggers.forEach(t => t.kill());
    currentScrollTriggers = [];

    const reveals = section.querySelectorAll('.gsap-reveal');
    
    reveals.forEach((element) => {
        // 使用 fromTo 强制每次进入页面时都从初始状态播放动画
        const anim = gsap.fromTo(element, 
            { 
                y: 30, 
                opacity: 0 
            },
            {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    toggleActions: "play none none reverse"
                }
            }
        );
        if(anim.scrollTrigger) {
            currentScrollTriggers.push(anim.scrollTrigger);
        }
    });
    ScrollTrigger.refresh();
};

// 页面切换逻辑
const showPage = (hash, isInitial = false) => {
    const pageId = hash.replace('#', '') || 'home';
    const validPages = ['home', 'services', 'andcount', 'profile'];
    const targetId = validPages.includes(pageId) ? pageId : 'home';

    const mainContainer = document.getElementById('main-content');
    
    const transitionPage = () => {
        // 1. 隐藏所有页面
        document.querySelectorAll('.page-section').forEach(sec => {
            sec.classList.add('hidden');
            sec.classList.remove('flex');
        });

        // 2. 显示目标页面
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
            targetSection.classList.remove('hidden');
            if(targetId === 'home') {
                targetSection.classList.add('flex'); // Home页面需要Flex居中
            }
        }

        // 3. 更新导航栏高亮状态
        document.querySelectorAll('.nav-link').forEach(link => {
            if (link.getAttribute('href') === '#' + targetId) {
                link.classList.add('text-fj-primary');
                link.classList.remove('text-fj-textPri');
            } else {
                link.classList.remove('text-fj-primary');
                link.classList.add('text-fj-textPri');
            }
        });

        // 4. 瞬间滚动回顶部
        window.scrollTo(0, 0);

        // 5. 容器淡入 & 执行新页面的 GSAP 动画
        if (!isInitial) {
            gsap.to(mainContainer, { opacity: 1, duration: 0.3 });
        }
        initGSAPForPage(targetSection);
    };

    if (isInitial) {
        // 初始加载不需要淡出效果
        transitionPage();
    } else {
        // 切换页面时，先淡出容器
        gsap.to(mainContainer, { opacity: 0, duration: 0.2, onComplete: transitionPage });
    }
};

// 监听 URL Hash 变化来触发页面切换 (SPA 核心)
window.addEventListener('hashchange', () => {
    showPage(window.location.hash);
});

window.addEventListener('DOMContentLoaded', () => {
    // 初始化背景
    initWebGL();
    // 初始加载时根据当前 Hash 显示对应页面
    showPage(window.location.hash || '#home', true);
});
